import { ROUTES_CONFIG } from "@/constants"
import { constructUrl } from "@/utils/constructUrl"
import { useIsDesktop } from "@/utils/useIsDesktop"

import { ALL_SECTIONS, Section } from "./tearOutSection.state"

const withoutTrailingSlash = (url: string) => url.replace(/\/+$/, "")

const here = withoutTrailingSlash(
  window.location.origin + window.location.pathname,
)

export const tornOutDocumentSection: Section | null =
  ALL_SECTIONS.find(
    (section) =>
      withoutTrailingSlash(constructUrl(ROUTES_CONFIG[section])) === here,
  ) ?? null

export const isTornOutDocument = tornOutDocumentSection !== null

// Torn-out windows can be narrower than the desktop breakpoint, but must keep
// their pop-in icon
export const useShowTearOut = () => useIsDesktop() || isTornOutDocument
